import { html } from "/WebInterface/new-ui/assets/js/utils/te.js";

export const optionElementTemplate = html`
  <option selected="true" value="${"value"}">${"label"}</option>
`;

export const dropdownOptionTemplate = html`
  <p class="autocomplete-option" option-name="${"name"}">${"label"}</p>
`;

export const dropdownHelperTextTemplate = html`
  <p class="helper-text">${"label"}</p>
`;

export const autoCompleteChip = html` <span class="autocomplete-selected-option"
  ><span value='${"value"}'>${"label"}</span><i class="icon-remove"></i
></span>`;
